import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompromisedPasswordService {
  private readonly HIBP_API = 'https://api.pwnedpasswords.com/range';

  constructor(private http: HttpClient) { }

  isPasswordCompromised(password: string): Observable<boolean> {
    if (!password) {
      return of(false);
    }

    // k-anonymity: only the first 5 chars of the SHA-1 hash are sent to the API
    return from(this.sha1Hex(password)).pipe(
      switchMap(hash => {
        const prefix = hash.slice(0, 5);
        const suffix = hash.slice(5);
        return this.http.get(`${this.HIBP_API}/${prefix}`, { responseType: 'text' }).pipe(
          map(response => response?.split('\n').some(line => line.split(':')[0].toUpperCase() === suffix) ?? false)
        );
      }),
      catchError(() => of(false))
    );
  }

  private sha1Hex(value: string): Promise<string> {
    return crypto.subtle.digest('SHA-1', new TextEncoder().encode(value)).then(
    buffer => Array.from(new Uint8Array(buffer))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
    );
  }
}

export class CompromisedPasswordMockService {
  isPasswordCompromised() {
    return of(false);
  }
}